/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpacknet2Inputs */

const en_creditpacknet2 = /** @type {(inputs: Creditpacknet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plus VAT`)
};

const de_creditpacknet2 = /** @type {(inputs: Creditpacknet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zzgl. USt.`)
};

/**
* | output |
* | --- |
* | "plus VAT" |
*
* @param {Creditpacknet2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditpacknet2 = /** @type {((inputs?: Creditpacknet2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpacknet2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditpacknet2(inputs)
	return de_creditpacknet2(inputs)
});
export { creditpacknet2 as "creditPackNet" }